import { render } from "./NavLink.vue?vue&type=template&id=b1511922&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=b1511922&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1511922"]])

export default __exports__